import SvgIcon from '@/components/icon/Index.vue'; // 引入icon元件

// 引入所有SVG檔
const requireAll = requireContext => requireContext.keys().map(requireContext);
const req = require.context('@/assets/images/icons', true, /\.svg$/);
requireAll(req);

export function setupVueSvgIcon(app) {
    app.component(SvgIcon.name, SvgIcon);
}
